module.exports = __webpack_public_path__ + "media/images/link_icon_w-17b8958dab86f65ab7e68bb1b1fcc4b3.png";